import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ftaz83cznh: FaireBrandEntity = {
  token: "b_ftaz83cznh",
  type: "brand",
  name: "Ancientveda",
  avatarUrl:
    "https://cdn.faire.com/fastly/3abbaf17004cc1e6f7ed2fa07bf765c1a64c5545f83be884b071001a702a44d5.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/9879466ff71dc03bbde5887088bcbbb5889e6779a4e4664b704141ed8aa61f27.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/3abbaf17004cc1e6f7ed2fa07bf765c1a64c5545f83be884b071001a702a44d5.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/9879466ff71dc03bbde5887088bcbbb5889e6779a4e4664b704141ed8aa61f27.jpeg",
  location: "Ontario, CA, USA",
  minimumOrderDollars: 139,
  rating: 4.1,
  reviewCount: 23,
  isInsider: true,
  description:
    "\nIn a tranquil Indian village, AncientVeda began as a modest family endeavor. Devendra, deeply rooted in his cultural heritage, alongside his artistic wife Vibha and their children, embarked on a mission to preserve and share the treasures of ancient traditions. Crafting intricate religious artifacts, incense, and jewelry inspired by sacred texts, their journey faced challenges but thrived on determination and passion. Word of their handcrafted creations quickly spread, enchanting seekers and pilgrims, and soon, AncientVeda bridged the ancient with the modern, becoming a global symbol of spirituality and tradition, infused into every meticulously crafted item.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:39.174Z",
    importedBy: "entity-db-cli",
  },
};
